import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';


import App from './App.vue';

import Home from './view/homeVue.vue';
import Animaux from './view/animauxVue.vue';
import Legal from './view/legalVue.vue';
import Sos from './view/sosVue.vue';
import Ferme from './view/FermeVue.vue';
import Service from './view/serviceVue.vue';


import Adopter from './view/adopteVue.vue';
import Partenaire from './view/partenaireVue.vue';
import Shops from './view/shopVue.vue';
import Besoins from './view/besoinsVue.vue';
import Information from './view/informationVue.vue';
import AnimalPage from './view/animauxDetails.vue';
import NewsPage from './view/newsPage.vue';
import Signalement from './view/signalementVue.vue';
import Fourriere from './view/fourriereVue.vue';
import Benevoles from './view/benevoleVue.vue';
import Refugedescri from './view/refugedescriVue.vue';
import Combat from './view/combatVue.vue';
const routes = [
    { path: '/redirect', redirect: '/' },
    { path: '/', component: Home },
    { path: '/partenaires', component: Partenaire },
    { path: '/shops', component: Shops },
    { path: '/besoins', component: Besoins },
    { path: '/sos', component: Sos },
    { path: '/animaux_ferme', component: Ferme },
    { path: '/tarifs', component: Service },
    { path: '/fourriere', component: Fourriere },
    { path: '/adopte', component: Adopter },
    { path: '/combats', component: Combat },
    { path: '/benevoles', component: Benevoles },
    { path: '/qui-somme-nous', component: Refugedescri },




    { path: '/legal', component: Legal },
    { path: '/info_refuge', component: Information },
    { path: '/animaux', component: Animaux },
    { path: '/signalement', component: Signalement },
    { path: '/publication/:id', component: NewsPage },
    { path: '/animaux/:id', component: AnimalPage },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }

        if (to.hash) {
            return new Promise(resolve => {
                // Délai minimal pour laisser le DOM se rendre
                setTimeout(() => {
                    resolve({
                        el: to.hash,
                        behavior: 'smooth'
                    });
                }, 150);
            });
        }

        return { top: 0 };
    }
});

// Créer l'application Vue
const app = createApp(App);
app.config.globalProperties.$idSite = 37;


// Utiliser le routeur
app.use(router);

// Monter l'application
app.mount('#app');